import { getToken, clearToken } from "../auth/tokenStore";
import { logout } from "../slice/authSlice";
import { store } from "../store";
import { getIsRefreshing, setIsRefreshing, addSubscriber, notifySubscribers } from "../utils/refreshState";

export const setupAxiosInterceptors = (axiosInstance, refresh) => {
  axiosInstance.interceptors.request.use(
    (config) => {
      const token = getToken();
      if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );
  
  axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;
  
      if ([401, 403].includes(error.response?.status) && originalRequest && !originalRequest._retry) {
        if (getIsRefreshing()) {
          return new Promise((resolve) => {
            addSubscriber((token) => {
              originalRequest.headers["Authorization"] = `Bearer ${token}`;
              resolve(axiosInstance(originalRequest));
            });
          });
        }
  
        originalRequest._retry = true;
        setIsRefreshing(true);
  
        try {
          const newAccessToken = await refresh(localStorage.getItem("device_id"));
          notifySubscribers(newAccessToken);
          originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
          return axiosInstance(originalRequest);
        } catch (refreshError) {
          clearToken();
          store.dispatch(logout());
          return Promise.reject(refreshError);
        } finally {
          setIsRefreshing(false);
        }
      }
  
      return Promise.reject(error);
    }
  );
};
